// extracted by mini-css-extract-plugin
var _1 = "EntityProfileHeaderAddNewButton-moduleEntityProfileHeaderAddNewButton__hzcC3";
export { _1 as "EntityProfileHeaderAddNewButton" }
